

































import {Component, Vue, Prop, Mixins} from 'vue-property-decorator';
import NiceSelect from "./NiceSelect.vue";
import {Mixin} from "@/mixins";
import store from '@/store';

@Component({
    components: {
        NiceSelect
    },
    name: "Invoice",
})
export default class Invoice extends Mixins(Mixin) {
    store = store();

    get days() {
        let ret : {[key: string] : string} = {
            '': this.T('ch2-birth-pattern-day')
        };
        for(let i = 1; i < 32; i++) {
            let str = i.toString();
            let key = str.length === 1 ? '0' + str : str;
            ret[key] = str;
        }
        return ret;
    }

    get months() {
        let ret : {[key: string] : string} = {
            '': this.T('ch2-birth-pattern-month')
        };
        for(let i = 1; i < 13; i++) {
            let str = i.toString();
            let key = str.length === 1 ? '0' + str : str;
            ret[key] = str;
        }
        return ret;
    }

    get years() {
        let ret : {[key: string] : string} = {
            '': this.T('ch2-birth-pattern-year')
        };
        let curYear = (new Date()).getFullYear();
        for(let i = curYear; i > curYear - 100 ; i--) {
            let str = i.toString();
            ret[str] = str;
        }
        return ret;
    }
}
